import * as React from 'react'

import { type Icon } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import LoadingFooter from './LoadingFooter'
import LoadingState from './LoadingState'

interface Props {
  illustration?: React.ComponentProps<typeof Icon.Large>['icon']
  title?: string
  description?: string
}

const LoadingModal = ({
  illustration = 'table-file',
  title = i18n.t('custom_tables.modal.title'),
  description = i18n.t('custom_tables.modal.description'),
}: Props) => {
  return (
    <Modal
      illustration={illustration}
      title={title}
      description={description}
      footer={<LoadingFooter />}
    >
      <LoadingState />
    </Modal>
  )
}

export default observer(LoadingModal)
